(function () {

  'use strict';

  angular.module('eclipseApp.myAccount').directive('payNowCcPopover', function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modules/my-account/pay-now-redesign/pay-now-cc-popover.html'
    };

  });

})();
